import { Box, Button, Stack } from "@mui/joy";
import { theme } from "styles/theme";
import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import CustomTypography from "../../../../components/common/CustomTypography";
import { useOnboardingPromotionPage } from "../../../../hooks/useOnboardingPromotionPage";
import { usePromotionOnboardingTracking } from "../../../../hooks/usePromotionOnboardingTracking";

interface SelectOption {
  id: number;
  label: string;
}

export default function Motivation_3_Promotion({
  version = "promotion",
}: {
  version?: string; // v5...
}) {
  const navigate = useNavigate();
  const [isAnimating, setIsAnimating] = useState(false); // 애니메이션 상태 추가

  const pageKey = "motivation_3"; // 페이지를 구분할 키 값

  const { singleSelectionId, updateSingleSelection, handleNext } =
    useOnboardingPromotionPage({
      pageKey,
      nextPageRoute: `/${version}-onboarding/motivation/4`,
    });

  const { trackSingleSelection } = usePromotionOnboardingTracking(pageKey);

  const selectOptionList: SelectOption[] = [
    { id: 1, label: "그렇다" },
    { id: 2, label: "가끔 그렇다" },
    { id: 3, label: "아니다" },
  ];

  // 버튼 선택 로직
  const handleOptionChange = (optionId: number) => {
    updateSingleSelection(optionId);
    trackSingleSelection(optionId);

    setTimeout(() => {
      setIsAnimating(false);
      handleNext({ singleSelectionId: optionId });
    }, 300);
  };
  return (
    <Stack spacing={5} sx={{ height: "100%" }}>
      <Stack spacing={2}>
        <CustomTypography
          variant="Subtitle"
          fontWeight={500}
          sx={{
            color: theme.vars.palette.Content.Strong,
          }}
        >
          {"다음 문장에 얼마만큼 해당하나요?"}
        </CustomTypography>
        <CustomTypography
          variant="Subtitle"
          fontWeight={500}
          sx={{
            color: theme.vars.palette.Content.Strong,
          }}
        >
          {"“나는 쉽게 포기하기 때문에 외부적인 동기부여 장치가 필요하다”"}
        </CustomTypography>
      </Stack>

      <Box sx={{ flex: 1, overflowY: "auto" }}>
        <Stack
          direction={"column"}
          sx={{
            width: "100%",
            whiteSpace: "nowrap",
            flexWrap: "wrap",
            gap: 1,
          }}
        >
          {selectOptionList.map(({ id, label }, optionIndex) => (
            <Stack key={`select_option_${id}`} sx={{ flexGrow: 1, gap: 1 }}>
              <Button
                fullWidth
                variant={"SingleSlim"}
                color={singleSelectionId === id ? "primary" : "secondary"}
                size={"lg"}
                sx={{
                  transition: "background-color 0.3s ease", // ease 애니메이션 추가
                }}
                onClick={() => {
                  handleOptionChange(id);
                }}
              >
                {label}
              </Button>
            </Stack>
          ))}
        </Stack>
      </Box>
    </Stack>
  );
}
